import { Component, OnInit } from '@angular/core';
import { InvoiceMenu } from '../../_models/invoiceMenu';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { Register } from '../../_models/register';
import { Address } from '../../_models/address';
import { Product } from '../../_models/product';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import * as _ from "lodash";


@Component({
  selector: 'app-seller-settings',
  templateUrl: './seller-settings.component.html',
  styleUrls: ['./seller-settings.component.scss'],
})
export class SellerSettingsComponent implements OnInit {


  bank: any = [{}];
  ifscError: string;
  accountNameError: string;
  accountTypeError: string;
  accountNumberError: string;
  bankNameError: string;
  description: string;
  config: string;
  address: Address = {};
  accountTypeList: any = [];
  addresses: Address[] = [];
  days: string;
  activeProduct: Product;
  activeProducts: any = [];  //Get all products of the Account owner
  returnProducts: any = [];
  reasonList: any;
  returnForDeleteProduct: any;
  returnForDelete: any;
  day: any = [];
  statusText1: string;
  statusText2: any;
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statesList: any;
  notificationId: any;
  notificationsList: any;
  currentPassword: string = '';
  currentPwdError: string = '';
  newPwdError: string = '';
  newPassword: string = '';
  pwdError: string = '';
  confirmPassword: string = '';
  confirmPwdError: string = '';
  emailError: string = '';
  email: string = '';
  password: string = '';


  ordersMainMenu: InvoiceMenu[] = [
    { displayName: "Address", tabClicked: "address", additional: "N" },
    { displayName: "Return Settings", tabClicked: "returnSettings", additional: "N" },
    // {displayName: "Notifications", tabClicked: "notifications", additional: "N"},
    { displayName: "Password Management", tabClicked: "passwordManagement", additional: "N" },
    { displayName: "Store Details", tabClicked: "storeDetails", additional: "N" },
    { displayName: "Bank Account Information", tabClicked: "bankAccountInfo", additional: "N" },
  ];
  tabClicked: string = "address";
  viewSeller: any = {};
  sellerDetail: any = {};

  constructor(private g: Globals, private api: ApiIntegration, private alertService: AlertService, public user: User, private router: Router, private http: HttpClient, public register: Register) {

    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;

      let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index > -1) {
        for (let ol of this.ordersMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.switchPosition(ol);
          }
        }
      } else {
        this.tabClicked = "address";
        this.populateTabData("address");
      }
    } else {
      this.tabClicked = "address";
      this.populateTabData("address");
    }
  }

  /* password management start*/

  typeCurrentPwd() {
    this.currentPwdError = '';
    if (!this.currentPassword) {
      this.currentPwdError = 'Please enter current password';
    }
  }

  typeNewPwd() {
    this.newPwdError = '';
    if (!this.newPassword) {
      this.newPwdError = 'Please enter new password';
    } else if (this.newPassword.length <= 5) {
      this.newPwdError = 'Password must be minimum 6 characters';
    }
  }

  typeConfirmPwd() {
    this.confirmPwdError = '';
    if (!this.confirmPassword) {
      this.confirmPwdError = 'Please enter confirm password';
    } else if (this.confirmPassword !== this.newPassword) {
      this.confirmPwdError = 'Password does not match';
    }
  }


  typeEmail() {
    this.emailError = '';
    if (!this.sellerDetail.emailAddress) {
      this.emailError = 'Please enter Email Address';
    }
  }


  typePwd() {
    this.pwdError = '';
    if (!this.sellerDetail.password) {
      this.pwdError = 'Please enter password';
    }
  }


  typeAccountType() {
    this.accountTypeError = "";
    if (this.bank.accountType == 0 || this.bank.accountType === null || this.bank.accountType === undefined) {
      this.accountTypeError = 'Please enter the AccountType';
    }
  }

  typeAccountName() {
    this.accountNameError = "";
    if (this.bank.accountName === "" || this.bank.accountName === null || this.bank.accountName === undefined) {
      this.accountNameError = ' please enter the AccountName'
    }
  }

  typeAccountNumber() {
    this.accountNumberError = "";
    if (this.bank.accountNumber === "" || this.bank.accountNumber === null || this.bank.accountNumber === undefined) {
      this.accountNumberError = "Please enter the Account Number"
    }
  }

  typeBankName() {
    this.bankNameError = "";
    if (this.bank.bankName === "" || this.bank.bankName === null || this.bank.bankName === undefined) {
      this.bankNameError = "Please enter the Bank Name"
    }
  }

  typeIfscCode() {
    this.ifscError = "";
    if (this.bank.ifscCode === "" || this.bank.ifscCode === null || this.bank.ifscCode === undefined) {
      this.ifscError = " Please enter the Ifsc Code"
    }

  }


  submitChangePassword() {
    this.typeNewPwd();
    this.typeCurrentPwd();
    this.typeConfirmPwd();
    if (this.confirmPwdError != "" || this.newPwdError != "" || this.currentPwdError != "") {
      return false;
    }
    let request = {
      "currentPassword": this.currentPassword,
      "newPassword": this.newPassword
    };
    this.g.loaderDisplay = "display";
    this.api.changePassword(request).subscribe((data: any = []) => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.alertService.success('Password', 'Changed Successfully');
      } else {
        this.alertService.error('Error', data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
      this.alertService.error('Error', 'Change Password Failed, please re-try.');
    });
  }

  /* password management end */

  populateTabData(triggered) {
    this.tabClicked = triggered;
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.currentPwdError = '';
    this.newPwdError = "";
    this.confirmPwdError = "";

    if (this.tabClicked === 'address') {
      this.getAddress();
      this.reasonSettingsList();
    } else if (this.tabClicked === 'returnSettings') {
      this.getProductsList();
      this.getDays();
      this.productList();
    } else if (this.tabClicked === 'storeDetails') {
      this.getStoreDetails();
    } else if (this.tabClicked === 'bankAccountInfo') {
      this.accountType();
      this.getBankDetailSeller();
    }
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[4].displayName) {
      this.ordersMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.ordersMainMenu) {
      if (tmp < this.ordersMainMenu.length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  getAddress() {
    this.api.getCustomerSellerById(this.user.sellerId).subscribe((data: any = []) => {
      this.viewSeller = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  getStoreDetails() {
    this.api.getStoreCredentials(this.user.sellerId).subscribe((data: any = []) => {
      this.sellerDetail = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }



  ngOnInit() {
  }

  selectedDeleteReturn(returnn) {
    this.returnForDelete = returnn;
  }

  selectedDeleteProduct(productReturn) {
    this.returnForDeleteProduct = productReturn;
  }

  typeReason() {
    this.statusText1 = "";
    if (this.config == '' || this.config === null || this.config === undefined || this.config === 'undefined') {
      this.statusText1 = 'Reason should not be empty';
      this.g.loaderDisplay = "";
      this.g.loaderDisplay = "";
      return false;
    }
  }


  submitReturn() {
    this.statusText1 = "";
    if (this.config == '' || this.config === null || this.config === undefined || this.config === 'undefined') {
      this.statusText1 = 'Reason should not be empty';
      this.g.loaderDisplay = "";
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTripleSetConfigs', {
      "child": "REASON",
      "config": this.config,
      "control": "AO_SELLER",
      "organizationId": 1,
      "parent": this.user.sellerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Settings', 'Returned Successfully');
          this.config = "";
          this.reasonSettingsList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  selectProduct() {
    this.statusText2 = "";
    if (this.activeProduct === null || this.activeProduct === undefined) {
      this.statusText2 = 'Please select product';
      this.g.loaderDisplay = "";
      return false;
    }
  }

  getDays() {
    this.api.getDays("1", "AO_SELLER", this.user.sellerId, "RETURN_DAYS").subscribe((data: any = []) => {
      this.day = data;
      this.days = this.day.config;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  submitProduct() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";
    if (this.activeProduct === null || this.activeProduct === undefined || this.config === 'activeProduct') {
      this.statusText2 = 'Please select product';
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateProductAsReturnOrNonReturn', {
      "accountOwnerId": this.user.accountOwnerId,
      "productId": this.activeProduct.productId,
      "organizationId": this.user.organizationId,
      "isReturnable": "NO",
      "sellerId": this.user.sellerId,
      "status": "ACTIVE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Product', 'submit Successfully');
          this.productList();
          console.log('Removed the product from the list');
          this.activeProduct = null;
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  submitDay(d) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTripleSetConfigs', {
      "child": "RETURN_DAYS",
      "config": d.config,
      "control": "AO_SELLER",
      "organizationId": 1,
      "parent": this.user.sellerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Submit', 'Day Successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  changeReturnProduct() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateProductAsReturnOrNonReturn', {
      "productId": this.returnForDeleteProduct.productId,
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "isReturnable": "YES",
      "sellerId": this.user.sellerId,
      "status": "ACTIVE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('NonReturnable Product', 'Deleted Successfully');
          this.productList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  reasonSettingsList() {
    this.api.getValues("1", "AO_SELLER", this.user.sellerId, "REASON").subscribe((data: any) => {
      this.reasonList = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  productList() {
    this.api.getReturnableProductListBySellerId(this.user.accountOwnerId, "1", "NO", this.user.sellerId).subscribe((data: any) => {
      this.returnProducts = data.getProductsResponses;
      this.getProductsList();
    }, err => {
      this.alertService.error('Error', err);

    });
  }

  getProductsList() {
    this.api.getAllSellerProductsByStatus(this.user.accountOwnerId, "1", this.user.sellerId, "ACTIVE").subscribe((data: any) => {
      this.activeProducts = _.cloneDeep(data.productsList);
      for (let rp of this.returnProducts) {
        for (let ap of this.activeProducts) {
          if (ap.productName === rp.productName) {
            let index = this.activeProducts.indexOf(ap);
            this.activeProducts.splice(index, 1);
          }
        }
      }
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  deleteReturn() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteTripleSetConfig', {
      "id": this.returnForDelete.id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Return', 'Deleted Successfully');

          this.reasonSettingsList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  updateStatus(n, id) {
  }

  saveChange() {
    let request1 = {
      "password": this.sellerDetail.password,
      "emailAddress": this.sellerDetail.emailAddress,
      "sellerId": this.sellerDetail.sellerId
    };
    this.g.loaderDisplay = "display";
    this.api.saveStoreCredentials(request1).subscribe((data: any = []) => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {


        this.alertService.success('Password', 'updated Successfully');
      } else {
        this.alertService.error('Error', data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
      this.alertService.error('Error', 'Change Password Failed, please re-try.');
    });
  }




  manageBankAccount() {
    this.g.loaderDisplay = "display";
    this.accountTypeError = "";
    this.accountNameError = "";
    this.accountNumberError = "";
    this.bankNameError = "";
    this.ifscError = "";

    if (this.bank.accountType == '' || this.bank.accountType === null || this.bank.accountType === undefined || this.bank.accountType === 'undefined') {
      this.accountTypeError = 'Please enter Account Type Name';
    }
    if (this.bank.accountName == '' || this.bank.accountName === null || this.bank.accountName === undefined || this.bank.accountName === 'undefined') {
      this.accountNameError = 'Please enter Account Name';
    }
    if (this.bank.accountNumber == '' || this.bank.accountNumber === null || this.bank.accountNumber === undefined || this.bank.accountNumber === 'undefined') {
      this.accountNumberError = 'Please enter AccountNumber';
    }
    if (this.bank.bankName == 0 || this.bank.bankName === null || this.bank.bankName === undefined) {
      this.bankNameError = 'Please enter Bank Name';
    }
    if (this.bank.ifscCode == 0 || this.bank.ifscCode === null || this.bank.ifscCode === undefined) {
      this.ifscError = "Please enter Ifsc Code";
    }
    if (this.ifscError != "" || this.accountNameError != "" || this.accountTypeError != "" || this.accountNumberError != "" || this.bankNameError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageBankAccountDetails', {

      "accountName": this.bank.accountName,
      "accountNumber": this.bank.accountNumber,
      "sellerId": this.user.sellerId,
      "accountType": this.bank.accountType,
      "bankName": this.bank.bankName,
      "ifscCode": this.bank.ifscCode,

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

          this.alertService.success('Bank details', 'Edited Successfully');

        } else {
          this.alertService.error('Error', data['message']);

        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getBankDetailSeller() {
    this.g.loaderDisplay = "display";
    this.api.getBankAccountDetails().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.bank = data;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }


  accountType() {
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "BANK_ACCOUNT_DETAILS", "ACCOUNT_TYPE", "ACCOUNT_TYPE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.accountTypeList = data.tripleSetConfigDTOS;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


}
